import React from "react";

function BS4_Flex() {
  return (
    <div>
      <h1>BS4_Flex Component</h1>
      <p>This is the BS4_Flex tutorial page content.</p>
    </div>
  );
}

export default BS4_Flex;
